import React from 'react';

import CSSModules from 'react-css-modules';

import FixedRatioImage from '../../FixedRatioImage';
import FullScreenImageButton from '../../FullScreenImageButton';
import {resolved, usePreloadImage} from '../../hooks/preloadImage';

import styles from './styles.module.scss';

type ImageQuizImageProps = {
  url?: string;
  thumbnailUrl?: string;
  backgroundColor?: string; // was previously a required prop, but not consistently passed in
  showFullScreenButton?: boolean;
  shouldFadeOut?: boolean;
  shouldFadeIn?: boolean;
  disabled?: boolean;
  editMode?: boolean;
  isPreview?: boolean;
  imageDataAutomation?: string;
};

const ImageQuizImage = ({
  backgroundColor = 'transparent',
  url = '',
  thumbnailUrl,
  showFullScreenButton = true,
  shouldFadeOut,
  shouldFadeIn,
  disabled,
  editMode,
  isPreview = false,
  imageDataAutomation,
}: ImageQuizImageProps): JSX.Element => {
  const fullImage = usePreloadImage(url);

  let styleName = 'image';
  if (shouldFadeOut) {
    styleName += ' fadeOut';
  } else if (shouldFadeIn) {
    styleName += ' fadeIn';
  }

  return (
    <div>
      <div styleName={styleName}>
        <FixedRatioImage
          backgroundColor={backgroundColor}
          url={thumbnailUrl || url}
          style={{borderRadius: isPreview ? 2 : 4}}
          isPlaceholder={!thumbnailUrl && !url}
          dataAutomation={imageDataAutomation}
        />
        {fullImage.status === resolved &&
          showFullScreenButton &&
          !isPreview && (
            <FullScreenImageButton
              image={fullImage}
              disabled={disabled}
              editMode={editMode}
            />
          )}
      </div>
    </div>
  );
};

export default CSSModules(ImageQuizImage, styles, {allowMultiple: true});
